export enum QualificationValidityTypeEnum {
    PERIOD = "period",
    FIXED_DATE = "fixed_date",
}
